<mat-toolbar class="fixed-top navbar">
  <button (click)="sidenavMenuWorkers.toggle()" *ngIf="userLogin" mat-icon-button class="example-icon"
    aria-label="Example icon-button with menu icon">
    <mat-icon>menu</mat-icon>
  </button>
  <span class="tittle-navbar" routerLink="/workers/dashboard">izidrink</span>
  <span class="spacer"></span>

</mat-toolbar>